import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { GridContentWidget } from '@eforall/dashboard';
import { AccProspectAlignedCommitment } from '@interfaces';
import { AppService } from '../../../../../services';
import { ReadonlyAccessWidget } from '../../../readonly-access/readonly-access.widget';
import { EntrepreneurProspectDialogDataService } from '../entrepreneur-prospect-dialog-data.service';
import { getSetup } from './grid/get-setup';

export interface AlignedCommitment extends AccProspectAlignedCommitment {
	startTrimester: string,
	endTrimester: string,
	updatedUTC: number,
}

@Component({
	selector: 'entrepreneur-prospect-dialog-aligned-commitments-part',
	standalone: true,
	imports: [GridContentWidget, ReadonlyAccessWidget],
	templateUrl: './aligned-commitments.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
})
export class EntrepreneurProspectDialogAlignedCommitmentsPart {

	public dialogBodyHeight = input.required<number>();

	private readonly util = inject(UtilityService);
	private readonly app = inject(AppService);
	public readonly dialogDataService = inject(EntrepreneurProspectDialogDataService);


	public setup = getSetup(this.util, this.dialogDataService);

	// subtracting 70 to account for padding and tabstrip, and 45 for readonly access widget if applicable
	public customHeight = computed(() => this.dialogBodyHeight() - 70 - (this.dialogDataService.isReadonly() ? 45 : 0));

	public alignedCommitments = computed<AlignedCommitment[]>(() => {
		const data = this.dialogDataService.dialogData();
		if (!data) return [];

		return data.alignedCommitments.map(c => ({
			...c,
			startTrimester: this.app.getTrimesterNameById(c.startTrimesterId),
			endTrimester: this.app.getTrimesterNameById(c.endTrimesterId),
			updatedUTC: Date.now()
		}
		));

	});
}